import React from 'react'
import './Header.css'
import logo from '../../images/logo.png';
import MenuIcon from '@mui/icons-material/Menu';

function Header({ toggleSidebar }) {
  return (
    <div className='Header'>
      <div className='HeaderContent'>
        <button className='MenuButton' onClick={toggleSidebar}>
          <MenuIcon />
        </button>
        <img src={logo} alt="Logo" className="HeaderLogo" />
        <h1 className='HeaderTitle'>セールスマネジメントシステム</h1>
        <div className='HeaderActions'>
          {/* ここにボタンを追加予定 */}
        </div>
      </div>
    </div>
  )
}

export default Header
